import { render, staticRenderFns } from "./ViewStudent.vue?vue&type=template&id=ba50202e&scoped=true"
import script from "./ViewStudent.vue?vue&type=script&lang=js"
export * from "./ViewStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba50202e",
  null
  
)

export default component.exports